"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIUnitDeclarationSchema = void 0;
const zod_1 = require("zod");
exports.SIUnitDeclarationSchema = zod_1.z.object({
    short: zod_1.z.string().optional(),
    long: zod_1.z.string().optional(),
    alternateNames: zod_1.z.string().array().optional(),
    usesSIPrefixes: zod_1.z.boolean().optional(),
    epsilon: zod_1.z.number().optional(),
});
//# sourceMappingURL=SIUnitDeclaration.js.map